import Container from "layouts/container/Container";
import style from "./SignUp.module.css";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import scan from 'resources/img/signup.png';
import cart from 'resources/img/cart.png';
import icon1 from 'resources/img/Group 50.png';
import banner from 'resources/img/imred.jpg';
import { QRCodeSVG } from 'qrcode.react';
import NiceModal from "@ebay/nice-modal-react";
import { useNavigate, useParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Inline from "layouts/container/Inline";
import Center from "layouts/wrapper/Center";
import favicon from "resources/img/favicon.ico";
import { useContext, useEffect, useState } from "react";
import { OutletContext } from "routes/front/main/WebSocketContainer";
import InputText from "components/inputs/signUp/InputText";
import { useLocation } from 'react-router-dom';
function SignUp() {
    const location = useLocation();

    useEffect(() => {

        const newUrl = `puffu://action`;
        window.location.href = newUrl;
        setTimeout(() => {
            window.location.href = "https://play.google.com/apps/test/com.worldintl.puffu/12";
            // window.location.href = "https://play.google.com/store/apps/details?id=com.worldintl.puffu&hl=en-US&ah=P69ZjaDp0PXvi-PKhpzdBG3oQwY";
        }, 1000); // 1초 후에 실행

    }, []);

    return (
        <Container>
            앱 있으면 앱켜고 없으면 설치
        </Container>
    );
    // const { id, sendMessage, unsubscribe } = useContext(OutletContext);

    // const onStartClick = () => {
    //     unsubscribe();
    //     sendMessage("start");

    // }

    // return (
    //     <Container height={"100%"}>
    //         <VerticalFlex gap={40} alignItems={"center"} justifyContent={"center"}>
    //             <FlexChild />
    //             <FlexChild >
    //                 <svg width="119" height="30" viewBox="0 0 119 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                     <g clip-path="url(#clip0_68_1629)">
    //                         <path d="M9.25606 22.3848L7.62655 29.6822H0.400024L5.99704 4.4602L10.4605 0.917786H21.442L24.205 4.4602L20.946 18.9132L16.4826 22.3848H9.25606ZM14.428 15.4417L16.0575 8.21516H12.5859L10.9564 15.4417H14.428Z" fill="black" />
    //                         <path d="M35.3282 22.4557L40.2167 0.917786H47.5141L41.7045 26.2106L37.2411 29.6822H26.4722L23.5674 26.2106L29.1644 0.917786H36.4618L31.5732 22.4557H35.3282Z" fill="black" />
    //                         <path d="M46.8057 29.6822L52.6152 4.38935L57.1495 0.917786H71.6734L70.0439 8.14431H58.9916L58.2831 11.6867H69.052L67.4225 18.9132H56.6536L54.0322 29.6822H46.8057Z" fill="black" />
    //                         <path d="M70.9649 29.6822L76.7745 4.38935L81.2379 0.917786H95.7618L94.1323 8.14431H83.1508L82.4423 11.6867H93.2113L91.5818 18.9132H80.8128L78.1914 29.6822H70.9649Z" fill="black" />
    //                         <path d="M106.885 22.4557L111.773 0.917786H119.071L113.261 26.2106L108.798 29.6822H98.0998L95.195 26.2106L100.721 0.917786H108.019L103.13 22.4557H106.885Z" fill="black" />
    //                     </g>
    //                     <defs>
    //                         <clipPath id="clip0_68_1629">
    //                             <rect width="118.6" height="28.7644" fill="white" transform="translate(0.400024 0.917786)" />
    //                         </clipPath>
    //                     </defs>
    //                 </svg>
    //             </FlexChild>
    //             <FlexChild width={"80%"} >
    //                 <VerticalFlex gap={10}>
    //                     <FlexChild>
    //                         <InputText placeHolder={"이메일주소 또는 아이디"} />
    //                     </FlexChild>
    //                     <FlexChild>
    //                         <InputText placeHolder={"패스워드"} />
    //                     </FlexChild>
    //                 </VerticalFlex>
    //             </FlexChild>

    //             <FlexChild width={"80%"}>
    //                 <div style={{ borderRadius: "100px", backgroundColor: "#FE531F", height: "100%", padding: "10px", textAlign: "center" }} onClick={onStartClick}>
    //                     <P color={"white"}>가입완료</P>
    //                 </div>
    //             </FlexChild>
    //             <FlexChild />
    //         </VerticalFlex>
    //     </Container>
    // );
}

export default SignUp;

